<template>
    <main class="container_mobile" id="ServiceMobile">
        <!-- ##################### -->
        <!-- Section web -->
        <!-- ##################### -->
        <section class="container_mobile__section_web" id="web">
            <!-- article  top -->
            <article class="container_mobile__section_web__article_top">
                <aside class="container_mobile__section_web__article_top__aside">
                    <!-- div title -->
                    <div class="container_mobile__section_web__article_top__aside__div_title">
                        <h1 class="container_mobile__section_web__article_top__aside__div_title__h1">
                            Web
                        </h1>
                    </div>
                    <!-- div underline -->
                    <div class="container_mobile__section_web__article_top__aside__div_underline">

                    </div>
                </aside>
            </article>
            <!-- article bottom -->
            <article class="container_mobile__section_web__article_bottom">
                <swiper :pagination="true" :modules="modules" class="mySwiper">
                    <!-- site vitrine -->
                    <swiper-slide>
                        <aside class="container_mobile__section_web__article_bottom__aside_site_vitrine">
                            <div class="container_mobile__section_web__article_bottom__aside_site_vitrine__div_top">
                                <div
                                    class="container_mobile__section_web__article_bottom__aside_site_vitrine__div_top__div_title">
                                    <h1
                                        class="container_mobile__section_web__article_bottom__aside_site_vitrine__div_top__div_title__h1">
                                        Site vitrine
                                    </h1>
                                </div>
                            </div>
                            <!-- div middle -->
                            <div class="container_mobile__section_web__article_bottom__aside_site_vitrine__div_middle">
                                <div
                                    class="container_mobile__section_web__article_bottom__aside_site_vitrine__div_middle__div_img">
                                    <img src="@/assets/browser.png" alt="site vitrine"
                                        class="container_mobile__section_web__article_bottom__aside_site_vitrine__div_middle__div_img__img">
                                </div>
                            </div>
                            <!-- div bottom -->
                            <div class="container_mobile__section_web__article_bottom__aside_site_vitrine__div_bottom">
                                <div
                                    class="container_mobile__section_web__article_bottom__aside_site_vitrine__div_bottom__div">
                                    <button
                                        class="container_mobile__section_web__article_bottom__aside_site_vitrine__div_bottom__div__button">
                                        <router-link
                                            class="container_mobile__section_web__article_bottom__aside_site_vitrine__div_bottom__div__button__router-link"
                                            to="/site-vitrine">
                                            En savoir plus
                                        </router-link>
                                    </button>
                                </div>
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- application web -->
                    <swiper-slide>
                        <aside class="container_mobile__section_web__article_bottom__aside_application_web">
                            <div class="container_mobile__section_web__article_bottom__aside_application_web__div_top">
                                <div
                                    class="container_mobile__section_web__article_bottom__aside_application_web__div_top__div_title">
                                    <h1
                                        class="container_mobile__section_web__article_bottom__aside_application_web__div_top__div_title__h1">
                                        Application web
                                    </h1>
                                </div>
                            </div>
                            <!-- div middle -->
                            <div
                                class="container_mobile__section_web__article_bottom__aside_application_web__div_middle">
                                <div
                                    class="container_mobile__section_web__article_bottom__aside_application_web__div_middle__div_img">
                                    <img src="@/assets/commerce.jpg" alt="Application web"
                                        class="container_mobile__section_web__article_bottom__aside_application_web__div_middle__div_img__img">
                                </div>
                            </div>
                            <!-- div bottom -->
                            <div
                                class="container_mobile__section_web__article_bottom__aside_application_web__div_bottom">
                                <div
                                    class="container_mobile__section_web__article_bottom__aside_application_web__div_bottom__div">
                                    <button
                                        class="container_mobile__section_web__article_bottom__aside_application_web__div_bottom__div__button">
                                        <router-link
                                            class="container_mobile__section_web__article_bottom__aside_application_web__div_bottom__div__button__router-link"
                                            to="/application-web">
                                            En savoir plus
                                        </router-link>
                                    </button>
                                </div>
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- site wordpress -->
                    <swiper-slide>
                        <aside class="container_mobile__section_web__article_bottom__aside_site_wordpress">
                            <div class="container_mobile__section_web__article_bottom__aside_site_wordpress__div_top">
                                <div
                                    class="container_mobile__section_web__article_bottom__aside_site_wordpress__div_top__div_title">
                                    <h1
                                        class="container_mobile__section_web__article_bottom__aside_site_wordpress__div_top__div_title__h1">
                                        Site Wordpress
                                    </h1>
                                </div>
                            </div>
                            <!-- div middle -->
                            <div
                                class="container_mobile__section_web__article_bottom__aside_site_wordpress__div_middle">
                                <div
                                    class="container_mobile__section_web__article_bottom__aside_site_wordpress__div_middle__div_img">
                                    <img src="@/assets/digital.jpg" alt="Site Wordpress"
                                        class="container_mobile__section_web__article_bottom__aside_site_wordpress__div_middle__div_img__img">
                                </div>
                            </div>
                            <!-- div bottom -->
                            <div
                                class="container_mobile__section_web__article_bottom__aside_site_wordpress__div_bottom">
                                <div
                                    class="container_mobile__section_web__article_bottom__aside_site_wordpress__div_bottom__div">
                                    <button
                                        class="container_mobile__section_web__article_bottom__aside_site_wordpress__div_bottom__div__button">
                                        <router-link
                                            class="container_mobile__section_web__article_bottom__aside_site_wordpress__div_bottom__div__button__router"
                                            to="/wordpress">
                                            En savoir plus
                                        </router-link>
                                    </button>
                                </div>
                            </div>
                        </aside>
                    </swiper-slide>
                </swiper>
            </article>
        </section>
        <!-- ##################### -->
        <!-- Section "mes valeurs" -->
        <!-- ##################### -->
        <section class="container_mobile__section_valeurs">
            <article class="container_mobile__section_valeurs__article">
                <!-- display flex 
            flex direction="column" -->
                <!-- aside title -->
                <aside class="container_mobile__section_valeurs__article__aside_top">
                    <div class="container_mobile__section_valeurs__article__aside_top__div">
                        <h1 class="container_mobile__section_valeurs__article__aside_top__div__h1">
                            Mes valeurs
                        </h1>
                    </div>
                </aside>
                <aside class="container_mobile__section_valeurs__article__aside_bottom">
                    <div class="container_mobile__section_valeurs__article__aside_bottom__div_1">
                        <h2 class="container_mobile__section_valeurs__article__aside_bottom__div_1__h2">
                            Professionel
                        </h2>
                    </div>
                    <div class="container_mobile__section_valeurs__article__aside_bottom__div_2">
                        <h2 class="container_mobile__section_valeurs__article__aside_bottom__div_2__h2">
                            Joignable
                        </h2>
                    </div>
                    <div class="container_mobile__section_valeurs__article__aside_bottom__div_3">
                        <h2 class="container_mobile__section_valeurs__article__aside_bottom__div_3__h2">
                            Réactif
                        </h2>
                    </div>
                    <div class="container_mobile__section_valeurs__article__aside_bottom__div_4">
                        <h2 class="container_mobile__section_valeurs__article__aside_bottom__div_4__h2">
                            À l'écoute
                        </h2>
                    </div>
                </aside>
            </article>
        </section>
        <!-- ##################### -->
        <!-- Section industriel-->
        <!-- ##################### -->
        <section class="container_mobile__section_industriel" id="industriel">
            <!-- article  top -->
            <article class="container_mobile__section_industriel__article_top">
                <aside class="container_mobile__section_industriel__article_top__aside">
                    <!-- div title -->
                    <div class="container_mobile__section_industriel__article_top__aside__div_title">
                        <h1 class="container_mobile__section_industriel__article_top__aside__div_title__h1">
                            Industriel
                        </h1>
                    </div>
                    <!-- div underline -->
                    <div class="container_mobile__section_industriel__article_top__aside__div_underline">

                    </div>
                </aside>
            </article>
            <!-- article bottom -->
            <article class="container_mobile__section_industriel__article_bottom">
                <swiper :pagination="true" :modules="modules" class="mySwiper">
                    <!-- Conception -->
                    <swiper-slide>
                        <aside class="container_mobile__section_industriel__article_bottom__aside_conception">
                            <div
                                class="container_mobile__section_industriel__article_bottom__aside_conception__div_top">
                                <div
                                    class="container_mobile__section_industriel__article_bottom__aside_conception__div_top__div_title">
                                    <h1
                                        class="container_mobile__section_industriel__article_bottom__aside_conception__div_top__div_title__h1">
                                        Conception
                                    </h1>
                                </div>
                            </div>
                            <!-- div middle -->
                            <div
                                class="container_mobile__section_industriel__article_bottom__aside_conception__div_middle">
                                <div
                                    class="container_mobile__section_industriel__article_bottom__aside_conception__div_middle__div_img">
                                    <img src="@/assets/modification.jpg" alt="Conception"
                                        class="container_mobile__section_industriel__article_bottom__aside_conception__div_middle__div_img__img">
                                </div>
                            </div>
                            <!-- div bottom -->
                            <div
                                class="container_mobile__section_industriel__article_bottom__aside_conception__div_bottom">
                                <div
                                    class="container_mobile__section_industriel__article_bottom__aside_conception__div_bottom__div">
                                    <button
                                        class="container_mobile__section_industriel__article_bottom__aside_conception__div_bottom__div__button">
                                        <router-link
                                            class="container_mobile__section_industriel__article_bottom__aside_conception__div_bottom__div__button__router-link"
                                            to="/conception">
                                            En savoir plus
                                        </router-link>
                                    </button>
                                </div>
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- Mise en plan-->
                    <swiper-slide>
                        <aside class="container_mobile__section_industriel__article_bottom__aside_plan">
                            <div class="container_mobile__section_industriel__article_bottom__aside_plan__div_top">
                                <div
                                    class="container_mobile__section_industriel__article_bottom__aside_plan__div_top__div_title">
                                    <h1
                                        class="container_mobile__section_industriel__article_bottom__aside_plan__div_top__div_title__h1">
                                        Mise en plan
                                    </h1>
                                </div>
                            </div>
                            <!-- div middle -->
                            <div class="container_mobile__section_industriel__article_bottom__aside_plan__div_middle">
                                <div
                                    class="container_mobile__section_industriel__article_bottom__aside_plan__div_middle__div_img">
                                    <img src="@/assets/infra-convert.jpg" alt="Mise en plan"
                                        class="container_mobile__section_industriel__article_bottom__aside_plan__div_middle__div_img__img">
                                </div>
                            </div>
                            <!-- div bottom -->
                            <div class="container_mobile__section_industriel__article_bottom__aside_plan__div_bottom">
                                <div
                                    class="container_mobile__section_industriel__article_bottom__aside_plan__div_bottom__div">
                                    <button
                                        class="container_mobile__section_industriel__article_bottom__aside_plan__div_bottom__div__button">
                                        <router-link
                                            class="container_mobile__section_industriel__article_bottom__aside_plan__div_bottom__div__button__router-link"
                                            to="/mise-en-plan">
                                            En savoir plus
                                        </router-link>
                                    </button>
                                </div>
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- Rendu réaliste -->
                    <swiper-slide>
                        <aside class="container_mobile__section_industriel__article_bottom__aside_rendu">
                            <div class="container_mobile__section_industriel__article_bottom__aside_rendu__div_top">
                                <div
                                    class="container_mobile__section_industriel__article_bottom__aside_rendu__div_top__div_title">
                                    <h1
                                        class="container_mobile__section_industriel__article_bottom__aside_rendu__div_top__div_title__h1">
                                        Rendu réaliste
                                    </h1>
                                </div>
                            </div>
                            <!-- div middle -->
                            <div class="container_mobile__section_industriel__article_bottom__aside_rendu__div_middle">
                                <div
                                    class="container_mobile__section_industriel__article_bottom__aside_rendu__div_middle__div_img">
                                    <img src="@/assets/cropped-SW-Professional.jpg" alt="Rendu réaliste"
                                        class="container_mobile__section_industriel__article_bottom__aside_rendu__div_middle__div_img__img">
                                </div>
                            </div>
                            <!-- div bottom -->
                            <div class="container_mobile__section_industriel__article_bottom__aside_rendu__div_bottom">
                                <div
                                    class="container_mobile__section_industriel__article_bottom__aside_rendu__div_bottom__div">
                                    <button
                                        class="container_mobile__section_industriel__article_bottom__aside_rendu__div_bottom__div__button">
                                        <router-link
                                            class="container_mobile__section_industriel__article_bottom__aside_rendu__div_bottom__div__button__router"
                                            to="/rendu-realiste">
                                            En savoir plus
                                        </router-link>
                                    </button>
                                </div>
                            </div>
                        </aside>
                    </swiper-slide>
                </swiper>
            </article>
        </section>
        <!-- ##################### -->
        <!-- Section "autres prestaions" -->
        <!-- ##################### -->
        <section class="container_mobile__section_prestations">
            <article class="container_mobile__section_prestations__article">
                <aside class="container_mobile__section_prestations__article__aside_top">
                    <div class="container_mobile__section_prestations__article__aside_top__div">
                        <h1 class="container_mobile__section_prestations__article__aside_top__div__h1">
                            Autres prestaions
                        </h1>
                    </div>
                </aside>
                <!-- aside bottom -->
                <aside class="container_mobile__section_prestations__article__aside_bottom">
                    <swiper :modules="modules" class="mySwiper">
                        <!-- div traduction -->
                        <swiper-slide>
                            <div class="container_mobile__section_prestations__article__aside_bottom__div_1">
                                <a href=""
                                    class="container_mobile__section_prestations__article__aside_bottom__div_1__a">
                                    Traduction
                                </a>
                            </div>
                        </swiper-slide>
                        <!-- div juridique -->
                        <swiper-slide>
                            <div class="container_mobile__section_prestations__article__aside_bottom__div_2">
                                <a href=""
                                    class="container_mobile__section_prestations__article__aside_bottom__div_2__a">
                                    Juridique
                                </a>
                            </div>
                        </swiper-slide>
                        <!-- div développeur web -->
                        <swiper-slide>
                            <div class="container_mobile__section_prestations__article__aside_bottom__div_3">
                                <a href="https://www.anyouali.fr/"
                                    class="container_mobile__section_prestations__article__aside_bottom__div_3__a">
                                    Développeur web
                                </a>
                            </div>
                        </swiper-slide>
                        <!-- div autre -->
                        <swiper-slide>
                            <div class="container_mobile__section_prestations__article__aside_bottom__div_4">
                                <a href=""
                                    class="container_mobile__section_prestations__article__aside_bottom__div_4__a">
                                    autre
                                </a>
                            </div>
                        </swiper-slide>
                    </swiper>
                </aside>
            </article>
        </section>
        <!-- ##################### -->
        <!-- Section tir-->
        <!-- ##################### -->
        <section class="container_mobile__section_tir" id="tir">
            <!-- article  top -->
            <article class=" container_mobile__section_tir__article_top">
                <aside class="container_mobile__section_tir__article_top__aside">
                    <!-- div title -->
                    <div class="container_mobile__section_tir__article_top__aside__div_title">
                        <h1 class="container_mobile__section_tir__article_top__aside__div_title__h1">
                            Tir
                        </h1>
                    </div>
                    <!-- div underline -->
                    <div class="container_mobile__section_tir__article_top__aside__div_underline">

                    </div>
                </aside>
            </article>
            <!-- article bottom -->
            <article class="container_mobile__section_tir__article_bottom">
                <swiper :pagination="true" :modules="modules" class="mySwiper">
                    <!-- instructeur de tir -->
                    <swiper-slide>
                        <aside class="container_mobile__section_tir__article_bottom__aside_instructor">
                            <div class="container_mobile__section_tir__article_bottom__aside_instructor__div_top">
                                <div
                                    class="container_mobile__section_tir__article_bottom__aside_instructor__div_top__div_title">
                                    <h1
                                        class="container_mobile__section_tir__article_bottom__aside_instructor__div_top__div_title__h1">
                                        Instructeur de tir
                                    </h1>
                                </div>
                            </div>
                            <!-- div middle -->
                            <div class="container_mobile__section_tir__article_bottom__aside_instructor__div_middle">
                                <div
                                    class="container_mobile__section_tir__article_bottom__aside_instructor__div_middle__div_img">
                                    <img src="@/assets/soldier.jpg" alt="Instructeur de tir"
                                        class="container_mobile__section_tir__article_bottom__aside_instructor__div_middle__div_img__img">
                                </div>
                            </div>
                            <!-- div bottom -->
                            <div class="container_mobile__section_tir__article_bottom__aside_instructor__div_bottom">
                                <div
                                    class="container_mobile__section_tir__article_bottom__aside_instructor__div_bottom__div">
                                    <button
                                        class="container_mobile__section_tir__article_bottom__aside_instructor__div_bottom__div__button">
                                        <router-link
                                            class="container_mobile__section_tir__article_bottom__aside_instructor__div_bottom__div__button__router-link"
                                            to="/instruction">
                                            En savoir plus
                                        </router-link>
                                    </button>
                                </div>
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- Défense-->
                    <swiper-slide>
                        <aside class="container_mobile__section_tir__article_bottom__aside_defense">
                            <div class="container_mobile__section_tir__article_bottom__aside_defense__div_top">
                                <div
                                    class="container_mobile__section_tir__article_bottom__aside_defense__div_top__div_title">
                                    <h1
                                        class="container_mobile__section_tir__article_bottom__aside_defense__div_top__div_title__h1">
                                        Défense
                                    </h1>
                                </div>
                            </div>
                            <!-- div middle -->
                            <div class="container_mobile__section_tir__article_bottom__aside_defense__div_middle">
                                <div
                                    class="container_mobile__section_tir__article_bottom__aside_defense__div_middle__div_img">
                                    <img src="@/assets/child.jpg" alt="Défense"
                                        class="container_mobile__section_tir__article_bottom__aside_defense__div_middle__div_img__img">
                                </div>
                            </div>
                            <!-- div bottom -->
                            <div class="container_mobile__section_tir__article_bottom__aside_defense__div_bottom">
                                <div
                                    class="container_mobile__section_tir__article_bottom__aside_defense__div_bottom__div">
                                    <button
                                        class="container_mobile__section_tir__article_bottom__aside_defense__div_bottom__div__button">
                                        <router-link
                                            class="container_mobile__section_tir__article_bottom__aside_defense__div_bottom__div__button__router-link"
                                            to="/defense">
                                            En savoir plus
                                        </router-link>
                                    </button>
                                </div>
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- Tir de combat -->
                    <swiper-slide>
                        <aside class="container_mobile__section_tir__article_bottom__aside_combat">
                            <div class="container_mobile__section_tir__article_bottom__aside_combat__div_top">
                                <div
                                    class="container_mobile__section_tir__article_bottom__aside_combat__div_top__div_title">
                                    <h1
                                        class="container_mobile__section_tir__article_bottom__aside_combat__div_top__div_title__h1">
                                        Tir de combat
                                    </h1>
                                </div>
                            </div>
                            <!-- div middle -->
                            <div class="container_mobile__section_tir__article_bottom__aside_combat__div_middle">
                                <div
                                    class="container_mobile__section_tir__article_bottom__aside_combat__div_middle__div_img">
                                    <img src="@/assets/youth.jpg" alt="Tir de combat"
                                        class="container_mobile__section_tir__article_bottom__aside_combat__div_middle__div_img__img">
                                </div>
                            </div>
                            <!-- div bottom -->
                            <div class="container_mobile__section_tir__article_bottom__aside_combat__div_bottom">
                                <div
                                    class="container_mobile__section_tir__article_bottom__aside_combat__div_bottom__div">
                                    <button
                                        class="container_mobile__section_tir__article_bottom__aside_combat__div_bottom__div__button">
                                        <router-link
                                            class="container_mobile__section_tir__article_bottom__aside_combat__div_bottom__div__button__router"
                                            to="/istc">
                                            En savoir plus
                                        </router-link>
                                    </button>
                                </div>
                            </div>
                        </aside>
                    </swiper-slide>
                </swiper>
            </article>
        </section>

    </main>
</template>

<script >
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

// import "swiper/css/navigation";
import "swiper/css/pagination";
// import "@/style/styles.css";


// import required modules
import { Pagination } from "swiper";

export default {
    name: 'ServicesMobile',
    components: {
        Swiper,
        SwiperSlide
    },

    setup() {
        return {
            modules: [Pagination],
        };
    },
};
</script>

<style  lang=scss scoped>
@import "@/style/components/Services/ServicesMobile.scss";
@import "@/style/style.scss";


@media screen and(min-width: 926px) {
    #ServiceMobile {
        display: none;
    }
}
</style>